import React from 'react'
import { getURLQueryParameter } from '../../../services/config'
import { GetCourseDetails } from '../../../services/api-requests/api-request'
import { ICourse, ICourseLessonContent } from '../../../interfaces/ICourse'
import { IPaymentsPlan } from '../../../interfaces/IPaymentsPlan'
import { ISchool } from '../../../interfaces/school.interface'
import { Button, CircularProgress, Hidden, Typography } from '@mui/material'
import { AnalyticService } from '../../../lib/analytics/analyticService'
import CourseDetailsComponentLarge from './CourseDetailsComponentLarge'
import CourseDetailsComponentSmall from './CourseDetailsComponentSmall'
import useUserAuthStatus from '../../Auhentication/useUserAuthStatus'
import useUserAuthSchoolDetails from '@/components/Auhentication/useUserAuthSchoolDetails'

export interface ICourseInfo {
  school_details: ISchool
  course_slug: string
  course_id: string
  course_details: ICourse
  course_lesson_content: Array<ICourseLessonContent>
  mirror_course_lesson_content: Array<ICourseLessonContent> | null
  payment_plans: IPaymentsPlan[]
}

const CourseDetailsComponent = (props: {
  courseId: string
  schoolDetailsFromCourse?: ISchool
  courseInfo?: ICourseInfo
}) => {
  const [onClient, setOnClient] = React.useState(false)
  const [courseDetailsLoading, setCourseDetailsLoading] = React.useState(false)
  const [courseDetails, setCourseDetails] = React.useState<
    ICourseInfo | undefined
  >(props?.courseInfo || undefined)
  const useUserAuthSchoolHook = useUserAuthSchoolDetails()

  const [userHasAccessToPage] = React.useState<boolean>(
    useUserAuthSchoolHook.checkIfUserCanViewCourseDetails({
      courseId: props.courseId,
      school: props.schoolDetailsFromCourse,
    }),
  )
  const background_image =
    courseDetails?.course_details?.banner_image ||
    courseDetails?.course_details?.background_image ||
    props.schoolDetailsFromCourse?.background_image

  const userAuthHook = useUserAuthStatus()

  React.useEffect(() => {
    if (!props.courseInfo) {
      getCourseDetails()
    }

    setOnClient(true)
  }, [])

  React.useEffect(() => {
    if (onClient) {
      AnalyticService.onSchoolVisit({
        school_id: props.courseInfo?.school_details?._id,
        course_id: props.courseId,
      })
    }
  }, [onClient])

  // store coupon code in session if coupon in query
  React.useEffect(() => {
    console.log('Setting coupon', courseDetails?.course_id)
    if (courseDetails?.course_id) {
      const coupon = getURLQueryParameter('coupon')
      console.log({ coupon })
      coupon &&
        window.sessionStorage.setItem(
          `course_coupon_${courseDetails.course_id}`,
          coupon,
        )
    }
  }, [courseDetails?.course_id])

  const getCourseDetails = async () => {
    try {
      setCourseDetailsLoading(true)
      const response = await GetCourseDetails(
        props.courseId,
        props.schoolDetailsFromCourse?._id,
      )
      const responseData = response?.data?.data
      if (responseData) {
        const outputResult = {
          course_slug: props.courseId,
          course_id: responseData.course_details._id, // change state course_id to _id if it is a slug
          course_details: responseData.course_details,
          course_lesson_content: responseData.course_lesson_content,
          mirror_course_lesson_content:
            responseData.mirror_course_lesson_content,
          school_details: responseData.school_details,
          payment_plans: responseData.payment_plans,
        }
        setCourseDetails(outputResult)
        // console.log("course details response data", responseData);

        // AnalyticService.onSchoolVisit({
        //   school_id: outputResult.school_details._id,
        //   course_id: props.courseId,
        // });
      }
    } catch (err: any) {
      console.log(
        'Error getting course details',
        props.courseId,
        err,
        err && err.message,
      )
    }
    setCourseDetailsLoading(false)
  }

  if (!onClient || courseDetailsLoading) {
    return (
      <div
        style={{
          // backgroundColor: '#131313',
          // backgroundColor: '#1a1c1e',
          // color: '#fff',
          minHeight: '100vh',
        }}
      >
        <Typography align={'center'}>
          <CircularProgress size={20} style={{ margin: '50px 50px' }} />
        </Typography>
      </div>
    )
  }

  if (!courseDetails?.course_details) {
    return (
      <div style={{ textAlign: 'center', maxWidth: '1000px', margin: 'auto' }}>
        <div>
          <img
            style={{
              marginTop: '60px',
            }}
            width="300px"
            // height="120px"
            src="/static/img/asset_empty.svg"
          />
        </div>
        <Typography
          style={{ marginTop: '50px', fontWeight: 'bold' }}
          variant={'h5'}
        >
          Ooops! Nothing to see here.
        </Typography>
        <Typography variant={'body1'} style={{ padding: '10px' }}>
          Looks like you visited the wrong link or the course you are looking
          for has been deleted by the school.
        </Typography>
        <Button variant={'contained'} href={'/'} color={'primary'}>
          Back to home
        </Button>
      </div>
    )
  }

  if (!userHasAccessToPage) {
    return (
      <div style={{ textAlign: 'center', maxWidth: '1000px', margin: 'auto' }}>
        <div>
          <img
            style={{
              marginTop: '60px',
            }}
            width="300px"
            // height="120px"
            src="/static/img/asset_empty.svg"
          />
        </div>
        <Typography
          style={{ marginTop: '50px', fontWeight: 'bold' }}
          variant={'h5'}
        >
          Ooops! Nothing to see here.
        </Typography>
        <Typography variant={'body1'} style={{ padding: '10px' }}>
          Looks like you visited the wrong link or you don't have access to this
          page
        </Typography>
        <Button variant={'contained'} href={'/'} color={'primary'}>
          Back to home
        </Button>
      </div>
    )
  }

  return (
    <div>
      <div
        style={
          background_image
            ? {
                display: 'flex',
                minHeight: '300px',
                width: '100%',
                alignItems: 'center',
                backgroundImage: background_image
                  ? `linear-gradient(45deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('${background_image}')`
                  : "linear-gradient(45deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('/static/img/bg_img_3.jpeg')",
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                color: '#fff',
              }
            : {
                padding: '100px 20px',
                backgroundColor: '#1c1d1f',
                color: '#fff',
                minHeight: '300px',
              }
        }
      />
      <Hidden mdUp={true}>
        <CourseDetailsComponentSmall
          schoolDetailsFromCourse={courseDetails.school_details}
          courseDetails={courseDetails.course_details}
          courseLessonContent={
            courseDetails.mirror_course_lesson_content ||
            courseDetails.course_lesson_content
          }
          userDetails={userAuthHook.userDetails}
          paymentPlans={courseDetails.payment_plans}
        />
      </Hidden>
      <Hidden mdDown={true}>
        <CourseDetailsComponentLarge
          schoolDetailsFromCourse={courseDetails.school_details}
          courseDetails={courseDetails.course_details}
          courseLessonContent={
            courseDetails.mirror_course_lesson_content ||
            courseDetails.course_lesson_content
          }
          userDetails={userAuthHook.userDetails}
          paymentPlans={courseDetails.payment_plans}
        />
      </Hidden>
    </div>
  )
}

export default CourseDetailsComponent
